<template>
  <v-menu ref="menu" :close-on-content-click="false" full-width offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div class="account-icon-ctn" :class="{ 'collapsed': isCollapsed }" v-bind="attrs" v-on="on">
        <div class="account-icon pr-2">
          <v-btn icon>
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </div>
        <div class="account-text pl-2" :class="{ 'collapsed': isCollapsed }">
          <span class="account-text-content">{{ $t('profile.my') }}</span>
        </div>
      </div>
    </template>
    <v-list dense class="pa-5">
      <div class="navigation-menu-title mb-2">
        {{ profile.first_name }} {{ profile.last_name }}
      </div>
      <div class="navigation-menu-sub-title mb-4">{{ profile.email }}</div>
      <div class="navigation-menu-sub-title mb-2">{{ profile?.company?.name }}</div>
      <div class="navigation-menu-label mb-2">{{ $t('current_plan') }}</div>
      <div class="navigation-menu-plan-label mb-5">{{planName}}</div>
      <div class="mb-5">
        <router-link ter-link class="profile-btn py-2 px-3 font-weight-medigum" :to="{name: 'profile.info'}" @click.native="closeOnClick">
          {{ $t('profile.manage_my_account') }}
        </router-link>
      </div>
      <div class="border-bottom"></div>
      <v-row class="mt-1">
        <v-col cols="12" md="7">
          <LanguageSelect/>
        </v-col>
      </v-row>
      <div>
        <a class="primary-text d-flex" @click="openHelpCenterArticle('https://help.scantrust.com/hc/en-us')">
          <v-icon class="mr-1 primary-text">mdi-help-circle</v-icon>
          <span class="text-decoration-underline">{{ $t('profile.help_center') }}</span>
        </a>
      </div>
      <div class="d-flex">
        <div class="ml-auto">
          <v-btn text @click="logout" class="font-weight-medium text-capitalize px-0">
            <v-icon class="mr-1" size="18" color="#555555">mdi-logout</v-icon>
            <span class="navigation-menu-logout-text">{{ $t('logout') }}</span>
          </v-btn>
        </div>
      </div>
    </v-list>
  </v-menu>
</template>

<script>

import LanguageSelect from '@/components/LanguageSelect'
import { openHelpCenterArticle } from '@/utils/helpCenter'
import { getPlanName } from '@/const/plans'
import amplitude from 'amplitude-js'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfileNavigationMenu',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['profile', 'currentPlan']),

    planName () {
      return getPlanName(this.currentPlan)
    }
  },
  components: {
    LanguageSelect
  },
  methods: {
    logout () {
      parent.postMessage({ type: 'logout' }, '*')
    },
    openHelpCenterArticle,
    closeOnClick () {
      amplitude.getInstance().logEvent('Profile Management Clicked')
      this.$refs.menu.save()
    }
  }
}

</script>

<style lang="sass" scoped>

@import "@/variables.sass"

.account-icon-ctn
  display: flex
  align-items: center
  cursor: pointer
  position: relative
  padding-left: 7px
  width: 100%

  &.collapsed
    justify-content: center
    padding-left: 15px

.account-text
  transition: all 0.3s ease
  overflow: hidden
  flex: 1

  &.collapsed
    opacity: 0
    max-width: 0
    margin: 0
    padding: 0

.account-text-content
  white-space: nowrap
  display: inline-block
  min-width: max-content

.account-icon
  position: relative
  flex-shrink: 0

.menu-link
  a
    text-decoration: none
    color: $black !important

.navigation-menu-label
  font-size: 12px
  color: #5D5D5D
  font-style: normal
  font-weight: 400
  line-height: 24px
  letter-spacing: 0.15px

.navigation-menu-title
  font-size: 20px
  color: #000
  font-style: normal
  font-weight: 500
  line-height: 24px
  letter-spacing: 0.15px

@mixin navigation-menu-sub-title
  font-size: 16px
  color: #000
  font-style: normal
  font-weight: 400
  line-height: 24px
  letter-spacing: 0.5px

.navigation-menu-plan-label
  @include navigation-menu-sub-title
  letter-spacing: 0.5px
  font-weight: bold !important
  color: $primary

.navigation-menu-logout-text
  color: #555
  font-size: 14px
  font-style: normal
  font-weight: 500
  line-height: 24px
  letter-spacing: 0.15px

.profile-btn
  border: 1px solid $primary
  text-transform: uppercase
  font-weight: 500
  border-radius: 4px
  color: white
  background-color: $primary

  &:hover
    color: white
    background-color: darken($primary, 10%)
    border: 1px solid darken($primary, 10%)

</style>
